let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ddS7e")).then(() => parcelRequire('r0ivy'));